import { render, staticRenderFns } from "./pod.vue?vue&type=template&id=5fe74fe0&scoped=true&"
import script from "./pod.vue?vue&type=script&lang=js&"
export * from "./pod.vue?vue&type=script&lang=js&"
import style0 from "./pod.vue?vue&type=style&index=0&id=5fe74fe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe74fe0",
  null
  
)

export default component.exports